import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import APITokenUsersDataTable from '../../components/datatables/APITokenUsersDataTable';
import HeaderPortal from '../../portals/HeaderPortal';
import Breadcrumbs from './../../config/Breadcrumbs';

interface APITokenUsersListProps {
  
}

interface APITokenUsersListState {
}

class APITokenUsersListPage extends React.Component<APITokenUsersListProps & RouteComponentProps<RouteObject>, APITokenUsersListState> {
  constructor(props: APITokenUsersListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  render() {
    return (
      <Content >
        <HeaderPortal title="API Token Users" breadcrumbs={Breadcrumbs.apiTokenUserList()} />
        <Card>
        <APITokenUsersDataTable />
        </Card>
      </Content>
    );
  }
}

function mapStateToProps() {
  return {
    
  };
}

export default withRouter(connect(mapStateToProps)(APITokenUsersListPage));